import React from "react";

import { UserRef } from "@mapmycustomers/shared/types/User";
import { AvatarWithName } from "@mapmycustomers/ui";

import { RegistryProps } from "@app/component/FieldGrid/utils/ComponentRegistry";
import UserPreviewCard from "@app/component/UserPreviewCard";

import styles from "./OwnerField.module.scss";

const OwnerField = ({ entity, field }: RegistryProps) => {
  const value = field.getValueFor(entity) as UserRef;

  return (
    <UserPreviewCard userId={value.id}>
      <div className={styles.container}>
        <AvatarWithName actionOnHover className={styles.avatar} user={value} />
      </div>
    </UserPreviewCard>
  );
};

export default OwnerField;
